// extracted by mini-css-extract-plugin
module.exports = {"form":"LayoutOnlineReceptionFormSendMessage_form__1isEz","text":"LayoutOnlineReceptionFormSendMessage_text__xvszd"};